import React, {useId} from 'react';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';
import {TOOLTIP_DELAY, fixedPopper} from '../tooltipConfig';
import {TipBody, useStickyTip} from '../TipDetail';

/**
 * Erklär-Sprechblase für ein beliebiges Element des Auftrags-Editors.
 *
 * Im Original standen diese Erklärungen in `title`-Attributen. Im
 * Ordermanagement sind browsereigene Sprechblasen nicht zugelassen (sie sehen
 * auf jedem System anders aus und lassen sich nicht bedienen), deshalb hier
 * durchgängig `OverlayTrigger`. Der Text bleibt derselbe wie im Original,
 * sofern es dort einen gab; sonst erklärt er kurz, was das Element tut oder
 * was ein Klick auslöst.
 *
 * @param {React.ReactNode} tip - Inhalt der Sprechblase, möglichst kurz.
 * @param {React.ReactNode} [detail] - Langtext, den „mehr" aufklappt (Ticket #127).
 * @param {string} [placement="top"]
 * @param {React.ReactElement} children - Genau ein Element.
 */
export default function OeTip({tip, detail, placement = 'top', children}) {
    const id = useId();
    const sticky = useStickyTip(!!detail);

    if (!tip) {
        return children;
    }

    return (
        <OverlayTrigger
            placement={placement}
            flip
            delay={TOOLTIP_DELAY}
            {...(detail ? {show: sticky.show, onToggle: sticky.onToggle} : {})}
            popperConfig={fixedPopper([
                {name: 'flip', options: {fallbackPlacements: ['top', 'bottom', 'right', 'left'], padding: 8}},
                {name: 'preventOverflow', options: {padding: 8}},
            ])}
            overlay={
                <Tooltip
                    id={`oe-tip-${id}`}
                    {...sticky.tipProps}
                    className={`help-tooltip${detail ? ' tip-sticky' : ''}`}
                >
                    <TipBody tip={tip} detail={detail} open={sticky.open} onOpen={() => sticky.setOpen(true)}/>
                </Tooltip>
            }
        >
            {children}
        </OverlayTrigger>
    );
}
